import { Component, EventEmitter, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import {
	NgbAccordion,
	NgbCalendar,
	NgbDateParserFormatter,
	NgbDateStruct,
	NgbModal,
	NgbTooltip
} from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CONFIG } from '../../../assets/config';
import { environment } from '../../../environments/environment';
import EntranceTreesN0Request from '../../shared/mocks/entrance-trees-N0-request.mock.json';
import EntranceTreesN1Request from '../../shared/mocks/entrance-trees-N1-request.mock.json';
import EntranceTreesN2Request from '../../shared/mocks/entrance-trees-N2-request.mock.json';
import EntranceTreesN3Request from '../../shared/mocks/entrance-trees-N3-request.mock.json';
import EntranceTreesN4Request from '../../shared/mocks/entrance-trees-N4-request.mock.json';
import * as GetDecisionTreeRequestMOCK from '../../shared/mocks/get-decision-tree-request.mock.json';
import { ClaimStep } from '../../shared/models/claim-step';
import { CodeDescription } from '../../shared/models/code-decription';
import { DevicesBrands } from '../../shared/models/devices-brands';
import { EntranceTreesRequest } from '../../shared/models/dto/entrance-trees-request';
import {
	DamageCause,
	DamageDetail,
	DamageType,
	Group,
	OtherDamage,
	OtherthirdHarm,
	OwnDamage,
	ThirdHarm
} from '../../shared/models/dto/entrance-trees-response';
import { Insured } from '../../shared/models/dto/get-client-response';
import { GetDecisionTreeRequest } from '../../shared/models/dto/get-decision-tree-request';
import { GetDecisionTreeResult } from '../../shared/models/dto/get-decision-tree-response';
import { Relationship } from '../../shared/models/relationship';
import { CustomDateParserFormatter } from '../../shared/services/custom-date-format.service';
import { HomeserveService } from '../../shared/services/homeserve.service';
import { MasterDataService } from '../../shared/services/master-data.service';
import { StorageService } from '../../shared/services/storage.service';
import { ValidationService } from '../../shared/services/validation.service';
import { ClickToCallComponent } from '../click-to-call/click-to-call.component';
import { LlamanosComponent } from '../llamanos/llamanos.component';
import { DataLayerService } from '../../core/services/dataLayer.service';
import { StepTrackerService } from '../../core/services/stepTracker.service';
import { MedalliaService } from '../../core/services/medallia.service';
@Component({
	selector: 'datos-siniestro',
	templateUrl: './datos-siniestro.component.html',
	styleUrls: ['./datos-siniestro.component.scss'],
	providers: [
		{
			provide: NgbDateParserFormatter,
			useClass: CustomDateParserFormatter
		},
		DataLayerService
	]
})
export class DatosSiniestroComponent {
	@Output() nextStep: EventEmitter<undefined> = new EventEmitter();
	@Output() showC2CButton: EventEmitter<boolean> = new EventEmitter();
	@ViewChild('stepper') stepper?: MatStepper;
	@ViewChildren('acc') accordionComponentList: QueryList<NgbAccordion> = new QueryList();

	causeGroups: Group[] = [];
	damageTypes: DamageType[] = [];
	damageDetails: DamageDetail[] = [];
	damageCauses: DamageCause[] = [];

	ownDamages: OwnDamage[] = [];
	otherDamages: OtherDamage[] = [];
	thirdDamages: ThirdHarm[] = [];
	otherThirdDamages: OtherthirdHarm[] = [];

	ownDamagesChecked: { [key: string]: boolean } = {};
	otherDamagesChecked: { [key: string]: boolean } = {};
	thirdOwnDmgsChecked: { [key: string]: boolean } = {};
	thirdOtherDmgsChecked: { [key: string]: boolean } = {};

	accordionClass: string = 'col-6';
	damagedFormatted: string = '';
	dateFormatted: string = '';
	declarantRelationships: Relationship[] = [];
	checkActive: boolean = false;
	formGroup: FormGroup = new FormGroup({});
	isAccordionOpen: boolean = false;
	marginClass: string = 'mb-4';
	policies?: Insured[] = [];
	prefixList: string[];
	showStepSummary: { [key: string]: { [key: string]: any } } = {
		date: { stepNumber: 0, show: false, empty: true },
		details: { stepNumber: 1, show: false, empty: true },
		cause: { stepNumber: 2, show: false, empty: true }
	};

	//Variables necesarias para comprobar en caso de que los daños sean requeridos, si hay daños seleccionados o no
	requiredOwnDamages: boolean = false;
	requiredThirdDamages: boolean = false;

	today = new Date();
	todayObject: NgbDateStruct = {
		year: this.today.getFullYear(),
		month: this.today.getMonth() + 1 > 12 ? this.today.getMonth() : this.today.getMonth() + 1,
		day: this.today.getDate()
	};

	readTerm: boolean =  false;
	understandTerm: boolean = false;
	fields = [
		{field: "LEIDO_1",value: "N"},
		{field: "CONSENTIMIENTO",value: "N"},
		{field: "LEIDO_2",value: "N"}
	];

	readonly maxTextAreaChars = 255;
	remainingCommentChars: number = this.maxTextAreaChars;

	damageDetailIdWithDevices = this.masterService.getDamageDetailIdWithDevices();
	damageTypeIdWithDevices = this.masterService.getDamageTypeIdWithDevices();
	devices: DevicesBrands[] = [];

	get damagedDevices(): FormArray {
		return this.formGroup?.get('claimDetails')?.get('damagedDevices') as FormArray;
	}

	get claimOwnDamages() {
		return this.formGroup?.get('causerData')?.get('claimOwnDamages') as FormArray;
	}

	get claimOtherDamages() {
		return this.formGroup?.get('causerData')?.get('claimOtherDamages') as FormArray;
	}

	get thirdOwnDamages() {
		return this.formGroup?.get('thirdDamagedData')?.get('thirdOwnDamages') as FormArray;
	}

	get thirdOtherDamages() {
		return this.formGroup?.get('thirdDamagedData')?.get('thirdOtherDamages') as FormArray;
	}

	constructor(
		calendar: NgbCalendar,
		private formBuilder: FormBuilder,
		private homeserveService: HomeserveService,
		private storageService: StorageService,
		private masterService: MasterDataService,
		private translate: TranslateService,
		private validationService: ValidationService,
		private modalService: NgbModal,
    	private dataLayerService: DataLayerService,
		private stepTrackerService: StepTrackerService,
		private medalliaService: MedalliaService

	) {
		this.homeserveService.claimStep = ClaimStep.ClaimData;
		this.showC2CButton.emit(true);
		this.prefixList = this.masterService.getPhonePrefixList();
		this.initForm();
		this.getClaimData();
		this.loadMasterData();
		this.onLanguageChanges();
	}

	initForm() {
		this.formGroup = this.formBuilder.group({
			claimDate: [
				this.todayObject,
				[Validators.required, this.validationService.maxDateToday /*, this.validationService.dateValidation*/]
			],
			claimDetails: this.formBuilder.group({
				claimCauseGroup: ['', [Validators.required]],
				claimDamageType: ['', []],
				claimDamageDetail: ['', []],
				claimCause: ['', []],
				insuredHome: [true, []],
				damagedDevices: this.formBuilder.array([]),
				originFix: [true, []],
			}),
			causerData: this.formBuilder.group({
				radioHomeDamage: [false, [Validators.required]],
				causerRelationShip: ['', []],
				causerName: ['', []],
				causerSurname1: ['', []],
				causerSurname2: ['', []],
				causerEmail: ['', [this.validationService.emailValidation]],
				causerPhone: ['', []],
				causerPrefixPhone: [this.prefixList[0], []],
				claimOwnDamages: this.loadDamages('own'),
				claimOtherDamages: this.loadDamages('other')
			}),
			thirdDamagedData: this.formBuilder.group({
				radioThirdDamage: [false, [Validators.required]],
				thirdDamagedRelationShip: ['', []],
				thirdDamagedName: ['', []],
				thirdDamagedSurname1: ['', []],
				thirdDamagedSurname2: ['', []],
				thirdDamagedEmail: ['', [this.validationService.emailValidation]],
				thirdDamagedPhone: ['', []],
				thirdDamagedPrefixPhone: [this.prefixList[0], []],
				thirdDamagedAddress: ['', []],
				thirdOwnDamages: this.loadDamages('thirdOwn'),
				thirdOtherDamages: this.loadDamages('thirdOther')
			}),
			claimDescription: ['', [Validators.required]],
		});
		this.storageService.autoSaveForm(this.storageService.claimDataKey, this.formGroup);
		this.storageService.save('terms', this.fields);
		sessionStorage.setItem('step', '2');
	}

	newDamagedDevice() {
		this.damagedDevices.push(
			this.formBuilder.group({
				brand: ['', Validators.required],
				device: ['', Validators.required]
			})
		);
	}

	onLanguageChanges() {
		this.translate.onLangChange.subscribe(() => {
			this.causeGroups = this.homeserveService.getCauseGroupsLanguage();
			this.damageTypes = this.homeserveService.getDamageTypesLanguage();
			this.damageDetails = this.homeserveService.getDamageDetailsLanguage();
			this.damageCauses = this.homeserveService.getDamageCausesLanguage();
			const damageCause: DamageCause = this.homeserveService.getDamageInfoLanguage();
			this.ownDamages = damageCause?.damageInfo?.ownDamagesInfo ?? [];
			if (this.ownDamages.length) {
				this.ownDamages.map(ownDamage => {
					if (ownDamage.ownDamage.toLowerCase() === 'otros daños mobiliario') {
						ownDamage.ownDamage = this.translate.instant('claimData.causes.causerData.insuredHomeDamage.contentDamages');;
					}
					if (ownDamage.ownDamage.toLowerCase() === 'otros daños estructura') {
						ownDamage.ownDamage = this.translate.instant('claimData.causes.causerData.insuredHomeDamage.containerDamages');;
					}
				})
			}
			this.otherDamages = damageCause?.damageInfo?.otherDamagesInfo ?? [];
			this.thirdDamages = damageCause?.thirdHarmsInfo?.thirdHarmInfo ?? [];
			this.otherThirdDamages = damageCause?.thirdHarmsInfo?.otherthirdHarmInfo ?? [];
			const claimDetails = this.formGroup.get('claimDetails');
			const claimDetailsValue = claimDetails?.value;
			if (claimDetailsValue?.claimCauseGroup?.causeGroupId) {
				claimDetails
					?.get('claimCauseGroup')
					?.patchValue(
						this.causeGroups.find((cause) => cause.causeGroupId === claimDetailsValue.claimCauseGroup.causeGroupId)
					);
			}
			if (claimDetailsValue?.claimDamageType?.damageTypeId) {
				claimDetails
					?.get('claimDamageType')
					?.patchValue(
						this.damageTypes.find(
							(damageType) => damageType.damageTypeId === claimDetailsValue.claimDamageType.damageTypeId
						)
					);
			}
			if (claimDetailsValue?.claimDamageDetail?.damageDetailId) {
				claimDetails
					?.get('claimDamageDetail')
					?.patchValue(
						this.damageDetails.find(
							(damageDetail) => damageDetail.damageDetailId === claimDetailsValue.claimDamageDetail.damageDetailId
						)
					);
			}
			if (claimDetailsValue?.claimCause?.damageCauseId) {
				claimDetails
					?.get('claimCause')
					?.patchValue(
						this.damageCauses.find(
							(damageCause) => damageCause.damageCauseId === claimDetailsValue.claimCause.damageCauseId
						)
					);
			}
			this.loadMasterData();

			setTimeout(() => {
				this.onStepperUpdate();
			}, 100);
		});
	}

	loadDamages(damageKind: string) {
		const sessionData: any = this.storageService.get(this.storageService.claimDataKey);
		switch (damageKind) {
			case 'own':
				if (sessionData?.causerData?.claimOwnDamages?.length > 0) {
					sessionData?.causerData?.claimOwnDamages?.forEach(
						(damage: { [key: string]: OwnDamage }) => (this.ownDamagesChecked[damage['ownDamage'].id] = true)
					);
					return this.formBuilder.array(sessionData?.causerData?.claimOwnDamages);
				} else {
					return this.formBuilder.array([]);
				}
			case 'other':
				if (sessionData?.causerData?.claimOtherDamages?.length > 0) {
					sessionData?.causerData?.claimOtherDamages?.forEach(
						(damage: { [key: string]: OtherDamage }) =>
							(this.otherDamagesChecked[damage['otherDamage'].otherDamage] = true)
					);
					return this.formBuilder.array(sessionData?.causerData?.claimOtherDamages);
				} else {
					return this.formBuilder.array([]);
				}
			case 'thirdOwn':
				if (sessionData?.thirdDamagedData?.thirdOwnDamages?.length > 0) {
					sessionData?.thirdDamagedData?.thirdOwnDamages?.forEach(
						(damage: { [key: string]: ThirdHarm }) => (this.thirdOwnDmgsChecked[damage['thirdHarm'].thirdHarm] = true)
					);
					return this.formBuilder.array(sessionData?.thirdDamagedData?.thirdOwnDamages);
				} else {
					return this.formBuilder.array([]);
				}
			case 'thirdOther':
				if (sessionData?.thirdDamagedData?.thirdOtherDamages?.length > 0) {
					sessionData?.thirdDamagedData?.thirdOtherDamages?.forEach(
						(damage: { [key: string]: OtherthirdHarm }) =>
							(this.thirdOtherDmgsChecked[damage['otherthirdHarm'].otherthirdHarm] = true)
					);
					return this.formBuilder.array(sessionData?.thirdDamagedData?.thirdOtherDamages);
				} else {
					return this.formBuilder.array([]);
				}
			default:
				return this.formBuilder.array([]);
		}
	}

	private async getClaimData() {
		const sessionData: any = this.storageService.get(this.storageService.claimDataKey);
		if (sessionData) {
			if (sessionData?.claimDetails?.damagedDevices?.length > 0) {
				for (let index = 0; index < sessionData?.claimDetails?.damagedDevices?.length; index++) {
					this.newDamagedDevice();
				}
			}
			if (sessionData.claimDetails.claimCauseGroup) {
				this.isAccordionOpen = true;
				this.marginClass = '';
				this.accordionClass = 'col-12';
				this.callDamageType(sessionData.claimDetails.claimCauseGroup, 'no-reset');
			}
			if (sessionData.claimDetails.claimDamageType) {
				this.callDamageDetail(sessionData.claimDetails.claimDamageType, 'no-reset');
			}
			if (sessionData.claimDetails.claimDamageDetail) {
				this.callDamageCause(sessionData.claimDetails.claimDamageDetail, 'no-reset');
			}
			if (sessionData.claimDetails.claimCause) {
				this.callThirdDamage(sessionData.claimDetails.claimCause, 'no-reset');
			}
			this.formGroup.patchValue(sessionData);
			this.updateRemainingChars(this.formGroup.get('claimDescription')?.value);
		}
		this.storageService.save(this.storageService.claimDataKey, this.formGroup.value);

		// SE NECESITA COMPROBAR SI EL FORMULARIO PRECARGA ESTE VALOR PARA SU VALIDADOR
		if(this.formGroup.get('claimDetails')?.get('insuredHome')?.value == false){
			this.updateClaimDetailsControlValidators('originFix', [Validators.required]);
		}
		
	}

	private async loadMasterData() {
		this.declarantRelationships = await this.masterService.getCauseInjuredRelationships();
		this.devices = this.masterService.getDevices(this.translate.currentLang);
		let device: DevicesBrands | undefined;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		this.formGroup?.value?.claimDetails?.damagedDevices.forEach((damagedDevice: any) => {
			device = this.devices.find((device) => device.code === damagedDevice?.device?.code) ?? undefined;
			if (device) {
				damagedDevice.device.code = device.code;
				damagedDevice.device.description = device.description;
				if(device.brands){
					let brand: CodeDescription | undefined;
					damagedDevice.device.brands = device.brands;
					brand = device.brands.find((brand) => brand.code === damagedDevice?.brand.code);
					damagedDevice.brand = brand;
				}
			}
		});
	}

	updateClaimDetailsControlValidators(controlName: string, validators: ValidatorFn | ValidatorFn[] | null) {
		this.formGroup.get('claimDetails')?.get(controlName)?.setValidators(validators);
		this.formGroup.get('claimDetails')?.get(controlName)?.updateValueAndValidity({ emitEvent: false });
		this.formGroup.get('claimDetails')?.get(controlName)?.markAsUntouched();
	}

	callCauseGroups() {
		const request: EntranceTreesRequest = environment.useMock
			? EntranceTreesN0Request
			: {
					company: CONFIG.companyId,
					policyexternalId: this.homeserveService.getCurrentInsured()?.policy ?? '',
					productId: this.homeserveService.getCurrentInsured()?.productid ?? '',
					parametrizationType: CONFIG.parametrizationType,
					riskTypeId: CONFIG.riskTypeId,
					auditoryInfo: {
						originCall: CONFIG.originCall,
						transactionId: crypto.randomUUID()
					}
			  };

		this.homeserveService.getCauseGroups(request)?.subscribe({
			next: (response) => {
				this.causeGroups = response;
				this.stepper?.next();
			},
			error: (error) => {
				this.masterService.createClickToCall('especificar_C2C', 'Hubo un problema en la llamada al EntranceTrees');
			}
		});
	}

	callDamageType(causeGroup: Group, resetElements?: string) {
		if (!resetElements || resetElements !== 'no-reset') {
			this.resetFormData('causeGroup');
		}
		this.formGroup.get('claimDetails')?.get('claimCauseGroup')?.setValue(causeGroup);
		const request: EntranceTreesRequest = environment.useMock
			? EntranceTreesN1Request
			: {
					company: CONFIG.companyId,
					policyexternalId: this.homeserveService.getCurrentInsured()?.policy ?? '',
					productId: this.homeserveService.getCurrentInsured()?.productid ?? '',
					parametrizationType: CONFIG.parametrizationType,
					riskTypeId: CONFIG.riskTypeId,
					causeGroupId: causeGroup.causeGroupId,
					auditoryInfo: {
						originCall: CONFIG.originCall,
						transactionId: crypto.randomUUID()
					}
			  };
		this.homeserveService.getDamageTypes(request).subscribe({
			next: (response) => {
				this.damageTypes = response;
				if (this.causeBelongToGroup()) {
					this.updateClaimDetailsControlValidators('insuredHome', [Validators.required]);
				}
				if (this.damageTypes[0].damageTypeId === '1') {
					this.callThirdDamage(undefined, resetElements);
				} else {
					this.updateClaimDetailsControlValidators('claimDamageType', [Validators.required]);
				}
			},
			error: (error) => {
				this.masterService.createClickToCall('especificar_C2C', 'Hubo un problema en la llamada al EntranceTrees');
			}
		});
	}

	callDamageDetail(damageType: DamageType, resetElements?: string) {
		if (this.damageTypeIdWithDevices.includes(damageType.damageTypeId)) {
			if (this.damagedDevices.length === 0) {
				this.newDamagedDevice();
			}
		} else {
			this.damagedDevices.clear();
		}
		if (!resetElements || resetElements !== 'no-reset') {
			this.resetFormData('damageType');
		}
		this.formGroup.get('claimDetails')?.get('claimDamageType')?.setValue(damageType);
		const request: EntranceTreesRequest = environment.useMock
			? EntranceTreesN2Request
			: {
					company: CONFIG.companyId,
					policyexternalId: this.homeserveService.getCurrentInsured()?.policy ?? '',
					productId: this.homeserveService.getCurrentInsured()?.productid ?? '',
					parametrizationType: CONFIG.parametrizationType,
					riskTypeId: CONFIG.riskTypeId,
					causeGroupId: this.formGroup.value.claimDetails.claimCauseGroup.causeGroupId,
					damageTypeId: damageType.damageTypeId,
					auditoryInfo: {
						originCall: CONFIG.originCall,
						transactionId: crypto.randomUUID()
					}
			  };
		this.homeserveService.getDamageDetails(request)?.subscribe({
			next: (response) => {
				this.damageDetails = response;
				if (this.damageDetails[0].damageDetailId === '1') {
					this.callThirdDamage(undefined, resetElements);
				} else {
					this.updateClaimDetailsControlValidators('claimDamageDetail', [Validators.required]);
				}
			},
			error: (error) => {
				this.masterService.createClickToCall('especificar_C2C', 'Hubo un problema en la llamada al EntranceTrees');
			}
		});
	}

	callDamageCause(damageDetail: DamageDetail, resetElements?: string) {
		if (this.damageDetailIdWithDevices.includes(damageDetail.damageDetailId)) {
			if (this.damagedDevices.length === 0) {
				this.newDamagedDevice();
			}
		} else {
			this.damagedDevices.clear();
		}
		if (!resetElements || resetElements !== 'no-reset') {
			this.resetFormData('damageDetail');
		}
		this.formGroup.get('claimDetails')?.get('claimDamageDetail')?.setValue(damageDetail);
		const request: EntranceTreesRequest = environment.useMock
			? EntranceTreesN3Request
			: {
					company: CONFIG.companyId,
					policyexternalId: this.homeserveService.getCurrentInsured()?.policy ?? '',
					productId: this.homeserveService.getCurrentInsured()?.productid ?? '',
					parametrizationType: CONFIG.parametrizationType,
					riskTypeId: CONFIG.riskTypeId,
					causeGroupId: this.formGroup.value.claimDetails.claimCauseGroup.causeGroupId,
					damageTypeId: this.formGroup.value.claimDetails.claimDamageType.damageTypeId,
					damageDetailId: damageDetail.damageDetailId,
					auditoryInfo: {
						originCall: CONFIG.originCall,
						transactionId: crypto.randomUUID()
					}
			  };
		this.homeserveService.getDamageCauses(request)?.subscribe({
			next: (response) => {
				this.damageCauses = response;
				if (this.damageCauses[0].damageCauseId === '1') {
					this.callThirdDamage(undefined, resetElements);
				} else {
					this.updateClaimDetailsControlValidators('claimCause', [Validators.required]);
				}
			},
			error: (error) => {
				this.masterService.createClickToCall('especificar_C2C', 'Hubo un problema en la llamada al EntranceTrees');
			}
		});
	}

	callThirdDamage(damageCause?: DamageCause, resetElements?: string) {
		if (!resetElements || resetElements !== 'no-reset') {
			this.resetFormData('damageCause');
		}
		this.formGroup.get('claimDetails')?.get('claimCause')?.setValue(damageCause);
		const request: EntranceTreesRequest = environment.useMock
			? EntranceTreesN4Request
			: {
					company: CONFIG.companyId,
					policyexternalId: this.homeserveService.getCurrentInsured()?.policy ?? '',
					productId: this.homeserveService.getCurrentInsured()?.productid ?? '',
					parametrizationType: CONFIG.parametrizationType,
					riskTypeId: CONFIG.riskTypeId,
					causeGroupId: this.formGroup.value.claimDetails?.claimCauseGroup?.causeGroupId ?? '1',
					damageTypeId: this.formGroup.value.claimDetails?.claimDamageType?.damageTypeId ?? '1',
					damageDetailId: this.formGroup.value.claimDetails?.claimDamageDetail?.damageDetailId ?? '1',
					damageCauseId: damageCause?.damageCauseId ?? '1',
					auditoryInfo: {
						originCall: CONFIG.originCall,
						transactionId: crypto.randomUUID()
					}
			  };
		this.homeserveService.getDamageInfo(request).subscribe({
			next: (response: DamageCause) => {
				this.ownDamages = response?.damageInfo?.ownDamagesInfo ?? [];
				if (this.ownDamages.length) {
					this.ownDamages.map(ownDamage => {
						if (ownDamage.ownDamage.toLowerCase() === 'otros daños mobiliario') {
							ownDamage.ownDamage = this.translate.instant('claimData.causes.causerData.insuredHomeDamage.contentDamages');;
						}
						if (ownDamage.ownDamage.toLowerCase() === 'otros daños estructura') {
							ownDamage.ownDamage = this.translate.instant('claimData.causes.causerData.insuredHomeDamage.containerDamages');;
						}
					})
				}
				this.otherDamages = response?.damageInfo?.otherDamagesInfo ?? [];
				this.thirdDamages = response?.thirdHarmsInfo?.thirdHarmInfo ?? [];
				this.otherThirdDamages = response?.thirdHarmsInfo?.otherthirdHarmInfo ?? [];
			},
			error: (error) => {
				this.masterService.createClickToCall('especificar_C2C', 'Hubo un problema en la llamada al EntranceTrees');
			}
		});
	}

	causeBelongToGroup() {
		const causesWithOtherHomeDamages: boolean = this.masterService
			.getCausesWithOtherHomeDamages()
			.some((element) => element === this.formGroup.get('claimDetails')?.value['claimCauseGroup'].causeGroupId);
		if(!causesWithOtherHomeDamages) {
			this.formGroup?.get('claimDetails')?.get('insuredHome')?.patchValue(true);
		}
		return causesWithOtherHomeDamages;
	}

	causeGroupClickHandler(cause: Group) {
		this.collapseAccordions(false, cause.causeGroupId);
		if (this.isAccordionOpen) {
			this.callDamageType(cause);
		}
	}

	clearOwnOtherDamages(event: Event) {
		if ((event.target as HTMLInputElement).checked) {
			this.claimOwnDamages.clear();
			for (const key in this.ownDamagesChecked) {
				this.ownDamagesChecked[key] = false;
			}
			this.claimOtherDamages.clear();
			for (const key in this.otherDamagesChecked) {
				this.otherDamagesChecked[key] = false;
			}
		}
	}

	clearThirdDamages(event: Event) {
		if ((event.target as HTMLInputElement).checked) {
			this.thirdOwnDamages.clear();
			for (const key in this.thirdOwnDmgsChecked) {
				this.thirdOwnDmgsChecked[key] = false;
			}
			this.thirdOtherDamages.clear();
			for (const key in this.thirdOtherDmgsChecked) {
				this.thirdOtherDmgsChecked[key] = false;
			}
		}
	}

	existFalseInsuredHome() {
		return (
			this.formGroup.get('claimDetails')?.get('insuredHome')?.value !== (undefined || null) &&
			!this.formGroup.get('claimDetails')?.get('insuredHome')?.value
		);
	}

	collapseAccordions(collapseAll: boolean, causeGroupId?: string) {
		if (collapseAll) {
			this.formGroup.get('claimDetails')?.get('claimCauseGroup')?.setValue('');
			this.formGroup.get('claimDetails')?.get('claimCauseGroup')?.markAsUntouched();
			this.accordionComponentList.forEach((htmlElement) => htmlElement.collapseAll());
			this.accordionClass = 'col-6';
			this.marginClass = 'mb-4';
			this.isAccordionOpen = false;
		} else {
			if (!this.isAccordionOpen) {
				if (causeGroupId) {
					this.accordionComponentList.forEach((htmlElement) => {
						if (!htmlElement.activeIds.includes(causeGroupId)) {
							htmlElement.collapseAll();
						} else {
							this.accordionClass = 'col-12';
							this.marginClass = '';
							this.isAccordionOpen = true;
						}
					});
				}
			} else {
				if (causeGroupId) {
					this.formGroup.get('claimDetails')?.get('claimCauseGroup')?.setValue('');
					this.formGroup.get('claimDetails')?.get('claimCauseGroup')?.markAsUntouched();
					this.accordionClass = 'col-6';
					this.marginClass = 'mb-4';
					this.isAccordionOpen = false;
				}
			}
		}
	}

	hideSummary(step: string) {
		this.showStepSummary[step]['show'] = false;
		const stepSummary = Object.assign({}, this.showStepSummary);
		delete stepSummary[step];
		Object.keys(stepSummary).map((element) => this.checkStepEmptyness(element));
		this.readTerm = false;
		this.understandTerm = false;
	}

	checkStepEmptyness(step: string) {
		switch (step) {
			case 'date':
				if (!this.formGroup.get('claimDate')?.value) {
					this.showStepSummary['date']['empty'] = true;
				}
				break;
			case 'details':
				if (!this.formGroup.get('claimDetails')?.get('claimCauseGroup')?.value) {
					this.showStepSummary['details']['empty'] = true;
				}
				break;
			case 'cause':
				if (!this.formGroup.get('claimDescription')?.value) {
					this.showStepSummary['cause']['empty'] = true;
				}
				break;
		}
		this.showStepSummary[step]['show'] = true;
	}

	onSelectPrefix(formData: string, prefix: string) {
		if (formData === 'thirdDamagedData') {
			this.formGroup.get(formData)?.get('thirdDamagedPrefixPhone')?.patchValue(prefix);
			this.formGroup.get(formData)?.get('thirdDamagedPhone')?.patchValue('');
		}
		if (formData === 'causerData') {
			this.formGroup.get(formData)?.get('causerPrefixPhone')?.patchValue(prefix);
			this.formGroup.get(formData)?.get('causerPhone')?.patchValue('');
		}
	}

	openTooltip(infoTooltip: NgbTooltip, causeGroupHelp: string) {
		infoTooltip.open({ causeGroupHelp });
	}

	resetFormData(fromReset: string) {
		switch (fromReset) {
			case 'causeGroup':
				this.formGroup.get('claimDetails')?.get('insuredHome')?.setValue(null);
				this.updateClaimDetailsControlValidators('insuredHome', []);

				this.formGroup.get('claimDetails')?.get('originFix')?.setValue(null);
				this.updateClaimDetailsControlValidators('originFix', []);

				this.formGroup.get('claimDetails')?.get('claimDamageType')?.setValue('');
				this.updateClaimDetailsControlValidators('claimDamageType', []);
				this.formGroup.get('claimDetails')?.get('claimDamageDetail')?.setValue('');
				this.updateClaimDetailsControlValidators('claimDamageDetail', []);
				this.formGroup.get('claimDetails')?.get('claimCause')?.setValue('');
				this.updateClaimDetailsControlValidators('claimCause', []);
				this.resetOwnOtherDamages();
				break;
			case 'damageType':
				this.formGroup.get('claimDetails')?.get('claimDamageDetail')?.setValue('');
				this.updateClaimDetailsControlValidators('claimDamageDetail', []);
				this.formGroup.get('claimDetails')?.get('claimCause')?.setValue('');
				this.updateClaimDetailsControlValidators('claimCause', []);
				this.resetOwnOtherDamages();
				break;
			case 'damageDetail':
				this.formGroup.get('claimDetails')?.get('claimCause')?.setValue('');
				this.updateClaimDetailsControlValidators('claimCause', []);
				this.resetOwnOtherDamages();
				break;
			case 'damageCause':
				this.resetOwnOtherDamages();
				break;
		}
	}

	resetOwnOtherDamages() {
		this.claimOwnDamages.clear();
		this.claimOtherDamages.clear();
		this.thirdOwnDamages.clear();
		this.thirdOtherDamages.clear();
	}

	setCauseGroupIcon(causeId: string) {
		return this.masterService.getCausedIcons()[causeId];
	}

	setInsuredRelationship(relatedType: string, relationship: Relationship) {
		switch (relatedType) {
			case 'causer':
				this.formGroup.get('causerData')?.get('causerRelationShip')?.setValue(relationship);
				break;
			case 'damaged':
				this.formGroup.get('thirdDamagedData')?.get('thirdDamagedRelationShip')?.setValue(relationship);
				break;
		}
	}

	setOwnDamageArray(event: any, ownDamageSelected: OwnDamage) {
		const id = ownDamageSelected.id;
		if (event.target.checked) {
			this.ownDamagesChecked[ownDamageSelected.id] = true;
			const ownDamageForm = this.formBuilder.group({
				ownDamage: [ownDamageSelected, []]
			});
			this.claimOwnDamages.push(ownDamageForm);
		} else {
			const index = this.claimOwnDamages.controls.findIndex((control) => control.value.ownDamage.id === id);
			if (index !== -1) {
				this.claimOwnDamages.removeAt(index);
				this.ownDamagesChecked[ownDamageSelected.id] = false;
			}
		}
		if(Object.keys(this.ownDamagesChecked).some(key => this.ownDamagesChecked[key])){
			this.requiredOwnDamages = false;
		}
	}

	setOtherDamageArray(event: any, otherDamageSelected: OtherDamage) {
		const id = otherDamageSelected.id;
		if (event.target.checked) {
			this.otherDamagesChecked[otherDamageSelected.otherDamage] = true;
			const otherDamageForm = this.formBuilder.group({
				otherDamage: [otherDamageSelected, []]
			});
			this.claimOtherDamages.push(otherDamageForm);
		} else {
			const index = this.claimOtherDamages.controls.findIndex((control) => control.value.otherDamage.id === id);
			if (index !== -1) {
				this.claimOtherDamages.removeAt(index);
				this.otherDamagesChecked[otherDamageSelected.otherDamage] = false;
			}
		}
		if(Object.keys(this.otherDamagesChecked).some(key => this.otherDamagesChecked[key])){
			this.requiredOwnDamages = false;
		}
	}

	setThirdOwnDamageArray(event: any, thirdOwnDamageSelected: ThirdHarm) {
		const id = thirdOwnDamageSelected.id;
		if (event.target.checked) {
			this.thirdOwnDmgsChecked[thirdOwnDamageSelected.thirdHarm] = true;
			const thirdOwnDmgForm = this.formBuilder.group({
				thirdHarm: [thirdOwnDamageSelected, []]
			});
			this.thirdOwnDamages.push(thirdOwnDmgForm);
		} else {
			const index = this.thirdOwnDamages.controls.findIndex((control) => control.value.thirdHarm.id === id);
			if (index !== -1) {
				this.thirdOwnDamages.removeAt(index);
				this.thirdOwnDmgsChecked[thirdOwnDamageSelected.thirdHarm] = false;
			}
		}
		if(Object.keys(this.thirdOwnDmgsChecked).some(key => this.thirdOwnDmgsChecked[key])){
			this.requiredThirdDamages = false;
		}
	}

	setThirdOtherDamageArray(event: any, thirdOtherDamageSelected: OtherthirdHarm) {
		const id = thirdOtherDamageSelected.id;
		if (event.target.checked) {
			this.thirdOtherDmgsChecked[thirdOtherDamageSelected.otherthirdHarm] = true;
			const thirdOtherDmgForm = this.formBuilder.group({
				otherthirdHarm: [thirdOtherDamageSelected, []]
			});
			this.thirdOtherDamages.push(thirdOtherDmgForm);
		} else {
			const index = this.thirdOtherDamages.controls.findIndex((control) => control.value.otherthirdHarm.id === id);
			if (index !== -1) {
				this.thirdOtherDamages.removeAt(index);
				this.thirdOtherDmgsChecked[thirdOtherDamageSelected.otherthirdHarm] = false;
			}
		}
		if(Object.keys(this.thirdOtherDmgsChecked).some(key => this.thirdOtherDmgsChecked[key])){
			this.requiredThirdDamages = false;
		}
	}

	showDamageFormatted() {
		this.damagedFormatted = '';
		this.formGroup.get('causerData')?.get('radioHomeDamage')?.patchValue(true);
		this.formGroup.get('thirdDamagedData')?.get('radioThirdDamage')?.patchValue(false);
		if (this.formGroup.get('claimDetails')?.get('claimCauseGroup')?.value) {
			this.damagedFormatted = `${this.damagedFormatted}${
				this.formGroup.get('claimDetails')?.get('claimCauseGroup')?.value.causeGroupName
			}`;
		}
		if (this.formGroup.get('claimDetails')?.get('claimDamageType')?.value) {
			this.damagedFormatted = `${this.damagedFormatted}/${
				this.formGroup.get('claimDetails')?.get('claimDamageType')?.value.damageTypeDesc
			}`;
		}
		if (this.formGroup.get('claimDetails')?.get('claimDamageDetail')?.value) {
			this.damagedFormatted = `${this.damagedFormatted}/${
				this.formGroup.get('claimDetails')?.get('claimDamageDetail')?.value.damageDetailDesc
			}`;
		}
		if (this.formGroup.get('claimDetails')?.get('claimCause')?.value) {
			this.damagedFormatted = `${this.damagedFormatted}/${
				this.formGroup.get('claimDetails')?.get('claimCause')?.value.damageCauseDesc
			}`;
		}
		if (this.formGroup.get('claimDetails')?.get('claimCauseGroup')?.value?.causeGroupId === '06') {
			this.formGroup.get('causerData')?.get('radioHomeDamage')?.patchValue(false);
			this.formGroup.get('thirdDamagedData')?.get('radioThirdDamage')?.patchValue(true);
		}
	}

	showDateFormatted() {
		if (this.formGroup.get('claimDate')?.value) {
			const date: Date = new Date(
				this.formGroup.get('claimDate')?.value.year,
				this.formGroup.get('claimDate')?.value.month - 1,
				this.formGroup.get('claimDate')?.value.day
			);
			this.dateFormatted = date.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' });
		} else {
			this.dateFormatted = '';
		}
	}

	occurenceDateValid(dateSelected: string) {
		const todayDate = new Date();
		const dateStart: string = this.homeserveService.getCurrentInsured()?.dateStart ?? '';
		const dateEnd: string = this.homeserveService.getCurrentInsured()?.dateEnd ?? '';
		const startDate: Date = new Date(
			`${dateStart.substring(0, 4)}-${dateStart.substring(4, 6)}-${dateStart.substring(6, 8)}`
		);
		const endDate: Date = new Date(`${dateEnd.substring(0, 4)}-${dateEnd.substring(4, 6)}-${dateEnd.substring(6, 8)}`);
		const selectedDate: Date = new Date(
			`${dateSelected.substring(0, 4)}-${dateSelected.substring(4, 6)}-${dateSelected.substring(6, 8)}`
		);
		const selectedTodayDateDifference = todayDate.getTime() - selectedDate.getTime();
		const yearsDifference = selectedTodayDateDifference / (1000 * 60 * 60 * 24 * 365.25);

		return selectedDate >= startDate && selectedDate <= endDate && yearsDifference <= 2;
	}

	showSummary(step: string) {
		if (step === 'date') {
			this.formGroup.get('claimDate')?.markAllAsTouched();
			if (this.formGroup.get('claimDate')?.valid) {
				const occurenceDate = `${this.formGroup.get('claimDate')?.value.year}${this.formGroup
					.get('claimDate')
					?.value.month.toString()
					.padStart(2, '0')}${this.formGroup.get('claimDate')?.value.day.toString().padStart(2, '0')}`;
				if (!this.occurenceDateValid(occurenceDate)) {
					const modalRef = this.modalService.open(ClickToCallComponent, {
						centered: true,
						windowClass: 'modal-call',
						backdrop: 'static',
						keyboard: false
					});
					modalRef.componentInstance.motiveC2C = '00021';
					modalRef.componentInstance.submotiveC2C =
						'La fecha seleccionada no es válida para el periodo de la póliza seleccionada';
				} else {
					this.homeserveService.refreshInsured(occurenceDate);
					this.showStepSummary[step]['show'] = true;
					this.showStepSummary[step]['empty'] = false;
					this.showDateFormatted();
					if (this.causeGroups?.length === 0) {
						this.callCauseGroups();
					}
					if (this.showStepSummary['details']['empty']) {
						this.showStepSummary['details']['show'] = false;
					}
					this.stepTrackerService.updateNameEvent('modulo_hogar_paso_2_1');
   					const currentNameEvent = this.stepTrackerService.getCurrentEventName();
					this.dataLayerService.addDataToDataLayer({'event': currentNameEvent});
					this.stepTrackerService.updateStep('2_1');
					const currentStep = this.stepTrackerService.getCurrentStep();
					this.dataLayerService.addDataToDataLayer({
						'event': 'uaevent',
						'eventCategory': 'Funnel Hogar Siniestros',
						'eventAction': 'modulo_hogar',
						'eventLabel': `Step${currentStep}`
					});
				}
			}
		}
		if (step === 'details') {
			this.formGroup.get('claimDetails')?.markAllAsTouched();
			if (this.formGroup.get('claimDetails')?.valid) {
				this.showStepSummary[step]['show'] = true;
				this.showStepSummary[step]['empty'] = false;
				this.showDamageFormatted();
				if (this.showStepSummary['cause']['empty']) {
					this.showStepSummary['cause']['show'] = false;
				}
				this.stepper?.next();
				this.stepTrackerService.updateStep('2_2');
				const currentStep = this.stepTrackerService.getCurrentStep();
				this.stepTrackerService.updateNameEvent('modulo_hogar_paso_2_2');
				const currentNameEvent = this.stepTrackerService.getCurrentEventName();
				this.dataLayerService.addDataToDataLayer({'event': currentNameEvent});
				this.dataLayerService.addDataToDataLayer({
					'event': 'uaevent',
					'eventCategory': 'Funnel Hogar Siniestros',
					'eventAction': 'modulo_hogar',
					'eventLabel': `Step${currentStep}`
        });
			}
		}
		if (step === 'cause') {
			this.formGroup.get('causerData')?.markAllAsTouched();
			this.formGroup.get('thirdDamagedData')?.markAllAsTouched();
			this.formGroup.get('claimDescription')?.markAllAsTouched();
			this.requiredOwnDamages = this.formGroup.get('causerData')?.get('radioHomeDamage')?.value ? this.checkSomeOwnDmgSelected() : false;
			this.requiredThirdDamages = this.formGroup.get('thirdDamagedData')?.get('radioThirdDamage')?.value ? this.checkSomeThirdDmgSelected() : false;
			if (
				this.formGroup.get('causerData')?.valid &&
				this.formGroup.get('thirdDamagedData')?.valid &&
				this.formGroup.get('claimDescription')?.valid &&
				!this.requiredOwnDamages &&
				!this.requiredThirdDamages
			) {
				this.showStepSummary[step]['show'] = true;
				this.showStepSummary[step]['empty'] = false;
				this.stepper?.next();
				this.stepTrackerService.updateStep('2_3');
				const currentStep = this.stepTrackerService.getCurrentStep();
				this.stepTrackerService.updateNameEvent('modulo_hogar_paso_2_3');
				const currentNameEvent = this.stepTrackerService.getCurrentEventName();
				this.dataLayerService.addDataToDataLayer({'event': currentNameEvent});
				this.dataLayerService.addDataToDataLayer({
					'event': 'uaevent',
					'eventCategory': 'Funnel Hogar Siniestros',
					'eventAction': 'modulo_hogar',
					'eventLabel': `Step${currentStep}`
        });
			}
		}
	}

	checkSomeOwnDmgSelected(){
		return Object.keys(this.ownDamagesChecked).some(key => this.ownDamagesChecked[key]) || 
				Object.keys(this.otherDamagesChecked).some(key => this.otherDamagesChecked[key]) ? false : true;
	}

	checkSomeThirdDmgSelected(){
		return Object.keys(this.thirdOwnDmgsChecked).some(key => this.thirdOwnDmgsChecked[key]) || 
				Object.keys(this.thirdOtherDmgsChecked).some(key => this.thirdOtherDmgsChecked[key]) ? false : true;
	}

	onSelectBrand(damagedDevice: AbstractControl, brand: CodeDescription) {
		damagedDevice?.get('brand')?.patchValue(brand);
	}

	onSelectDevice(damagedDevice: AbstractControl, device: CodeDescription) {
		damagedDevice?.get('device')?.patchValue(device);
		damagedDevice?.get('brand')?.patchValue('');
	}

	removeDamagedDevice(index: number) {
		this.damagedDevices.removeAt(index);
	}

	onStepperUpdate() {
		if (this.stepper?.selectedIndex === 1) {
			const causeGroupId = this.formGroup?.value?.claimDetails?.claimCauseGroup?.causeGroupId;
			if (causeGroupId) {
				const accordionIndex = this.causeGroups.findIndex((causeGroup) => causeGroup.causeGroupId === causeGroupId);
				if (accordionIndex !== undefined) {
					const selectedAccordion = this.accordionComponentList?.get(accordionIndex);
					selectedAccordion?.expand(causeGroupId);
				}
			}
		}
	}

	updateRemainingChars(comments: string) {
		this.remainingCommentChars = this.maxTextAreaChars - comments.length;
	}

	disclaimerData(){
		if (this.readTerm && (this.understandTerm || !this.existDatosTercero() )) {
			this.fields[0].value = 'S';
			this.storageService.save('terms', this.fields);
		}
	}

	onSubmit() {
		this.disclaimerData();
		this.formGroup.markAllAsTouched();
		if (this.formGroup.valid) {
			this.stepTrackerService.updateNameEvent('modulo_hogar_paso_2');
    		const currentNameEvent = this.stepTrackerService.getCurrentEventName();
			this.dataLayerService.addDataToDataLayer({
				'event': currentNameEvent,
				'eventData_description' :this.getEventDataDescription(),
				'eventData_injured': this.getEventDataInjured(),
				'eventData_cause': this.getEventDataCause()
			
			});
			this.stepTrackerService.updateStep('2');
			const currentStep = this.stepTrackerService.getCurrentStep();
			this.dataLayerService.addDataToDataLayer({
				'event': 'uaevent',
				'eventCategory': 'Funnel Hogar Siniestros',
				'eventAction': 'modulo_hogar',
				'eventLabel': `Step${currentStep}`
			});
			this.storageService.save(this.storageService.claimDataKey, this.formGroup.value);
			const insuredHouse = this.formGroup.get('claimDetails')?.get('insuredHome')?.value ?? null;
			const originFix = this.formGroup.get('claimDetails')?.get('originFix')?.value ?? null;
			
			if (!insuredHouse && (!originFix || originFix === 1 )) {
				const modalRef = this.modalService.open(ClickToCallComponent, {
					centered: true,
					windowClass: 'modal-call',
					backdrop: 'static',
					keyboard: false
				});
				modalRef.componentInstance.motiveC2C = '10005_Tercero_causante';
				if(!originFix){
					modalRef.componentInstance.submotiveC2C = 'Tercero causante: Causante no ha reparado origen';
				}
				else if(originFix === 1){
					modalRef.componentInstance.submotiveC2C = 'Tercero causante: Lo desconozco';
				}


			} else {
				const request: GetDecisionTreeRequest = environment.useMock
					? GetDecisionTreeRequestMOCK
					: this.homeserveService.createDecisionTreeRequest();

				this.homeserveService.getDecisionTree(request).subscribe({
					next: (res: GetDecisionTreeResult) => {
						if (res.claimType && this.masterService.getClaimValidIds().includes(res.claimType)) {
							const claimData: any = this.storageService.get(this.storageService.claimDataKey);
							claimData.docList = [];
							res.compulsoryCompensableDocListInfo.map(obj => claimData.docList.push({ id: obj.compulsoryCompensableDoc, files: [] }));
							this.storageService.save(this.storageService.claimDataKey, claimData);
							this.nextStep.emit();
						} else if (res.claimType && this.masterService.getC2CIds().includes(res.claimType)) {
							this.masterService.manageDecisionTreeControlledErrors(res);
						} else if (res.claimType && this.masterService.getLlamanosIds().includes(res.claimType)) {
							const modalRef = this.modalService.open(LlamanosComponent, {
								centered: true,
								windowClass: 'modal-help',
								backdrop: 'static',
								keyboard: false
							});
							// modalRef.componentInstance.motiveLlamanos = '00019';
							modalRef.componentInstance.submotiveLlamanos = `Respuesta de getDecisionTree con claimType: ${res.claimType}`;
							modalRef.componentInstance.submotiveShown = `Respuesta del árbol de decisión fallida`;
						} else {
							const modalRef = this.modalService.open(LlamanosComponent, {
								centered: true,
								windowClass: 'modal-help',
								backdrop: 'static',
								keyboard: false
							});
							modalRef.componentInstance.submotiveLlamanos = `Respuesta de getDecisionTree no contemplada con claimType: ${res.claimType}`;
							modalRef.componentInstance.submotiveShown = `Respuesta del árbol de decisión fallida`;
						}
					},
					error: (error) => {
						const modalRef = this.modalService.open(ClickToCallComponent, {
							centered: true,
							windowClass: 'modal-call',
							backdrop: 'static',
							keyboard: false
						});
						modalRef.componentInstance.motiveC2C = '10009';
						modalRef.componentInstance.submotiveC2C = 'Fallo en la llamada de obtención del árbol de decisión.';
					}
				});
			}
		}
	}

	getEventDataInjured(): string {
		return this.formGroup.get('claimDetails')?.get('insuredHome')?.value ? 'Si' : 'No';
	}
	

	getEventDataDescription(): string {
		
		const claimDetails = this.formGroup.get('claimDetails');
		const damagetype = claimDetails?.get('claimDamageType')?.value?.damageTypeDesc ?? '';	
		
		return damagetype ;
	}

	getEventDataCause(): string {
		return this.existDatosTercero() ? 'Si' : 'No';
	}


	acceptTerms(term: number){
		term === 1 && (this.readTerm = !this.readTerm);
		term === 2 && (this.understandTerm = !this.understandTerm);
	}

	existDatosTercero() : boolean {
		if( 
			(this.formGroup.get('thirdDamagedData') && this.formGroup.get('thirdDamagedData')?.get('radioThirdDamage') && this.formGroup.get('thirdDamagedData')?.get('radioThirdDamage')?.value) 
			   &&
			   (
					( 
						(this.formGroup.get('thirdDamagedData')?.get('thirdDamagedName') &&  this.formGroup.get('thirdDamagedData')?.get('thirdDamagedName')?.value && this.formGroup.get('thirdDamagedData')?.get('thirdDamagedName')?.value.trim())
							||
						(this.formGroup.get('thirdDamagedData')?.get('thirdDamagedSurname1') &&  this.formGroup.get('thirdDamagedData')?.get('thirdDamagedSurname1')?.value && this.formGroup.get('thirdDamagedData')?.get('thirdDamagedSurname1')?.value.trim())
							||
						(this.formGroup.get('thirdDamagedData')?.get('thirdDamagedSurname2') &&  this.formGroup.get('thirdDamagedData')?.get('thirdDamagedSurname2')?.value && this.formGroup.get('thirdDamagedData')?.get('thirdDamagedSurname2')?.value.trim())
							||
						(this.formGroup.get('thirdDamagedData')?.get('thirdDamagedEmail') &&  this.formGroup.get('thirdDamagedData')?.get('thirdDamagedEmail')?.value && this.formGroup.get('thirdDamagedData')?.get('thirdDamagedEmail')?.value.trim())
							||
						(this.formGroup.get('thirdDamagedData')?.get('thirdDamagedPhone') &&  this.formGroup.get('thirdDamagedData')?.get('thirdDamagedPhone')?.value && this.formGroup.get('thirdDamagedData')?.get('thirdDamagedPhone')?.value.trim())
							||
						(this.formGroup.get('thirdDamagedData')?.get('thirdDamagedAddress') &&  this.formGroup.get('thirdDamagedData')?.get('thirdDamagedAddress')?.value && this.formGroup.get('thirdDamagedData')?.get('thirdDamagedAddress')?.value.trim())

					)
				)
					||
				(
					(this.formGroup.get('causerData') &&
						(this.formGroup.get('causerData')?.get('causerName') &&  this.formGroup.get('causerData')?.get('causerName')?.value && this.formGroup.get('causerData')?.get('causerName')?.value.trim())
							||
						(this.formGroup.get('causerData')?.get('causerSurname1') &&  this.formGroup.get('causerData')?.get('causerSurname1')?.value && this.formGroup.get('causerData')?.get('causerSurname1')?.value.trim())
							||
						(this.formGroup.get('causerData')?.get('causerSurname2') &&  this.formGroup.get('causerData')?.get('causerSurname2')?.value && this.formGroup.get('causerData')?.get('causerSurname2')?.value.trim())
							||
						(this.formGroup.get('causerData')?.get('causerEmail') &&  this.formGroup.get('causerData')?.get('causerEmail')?.value && this.formGroup.get('causerData')?.get('causerEmail')?.value.trim())
							||
						(this.formGroup.get('causerData')?.get('causerPhone') &&  this.formGroup.get('causerData')?.get('causerPhone')?.value && this.formGroup.get('causerData')?.get('causerPhone')?.value.trim())
					)
				)
		  ) {
			return true;
		} else {
			return false;
		}
	}

	onChangeInsuredHome(value:String){
		if(value && value == 'false'){
			this.updateClaimDetailsControlValidators('originFix', [Validators.required]);
		} else {
			this.updateClaimDetailsControlValidators('originFix', []);
		}
		this.formGroup.get('claimDetails')?.get('originFix')?.setValue(null);
	}
}
